import { render, staticRenderFns } from "./adminComponent.vue?vue&type=template&id=587f4268"
import script from "./adminComponent.vue?vue&type=script&lang=js"
export * from "./adminComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports